"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Rels_1 = require("../models/Rels");
const WmsRestClient_1 = __importDefault(require("../utils/WmsRestClient"));
class PropertiesAccessor {
    constructor(wmsRestClient) {
        if (!wmsRestClient) {
            const billboardHost = process.env.WMS_BILLBOARD_HOST;
            if (!billboardHost) {
                throw new Error('WMS_BILLBOARD_HOST must be present in the process environment');
            }
            // Not required in the environment, will be used if provided
            const s3BillboardUrl = process.env.WMS_S3_BILLBOARD_URL ?? '';
            const wmsAuthBasic = process.env.WMS_AUTH_BASIC;
            if (!wmsAuthBasic) {
                throw new Error('WMS_AUTH_BASIC must be present in the process environment');
            }
            wmsRestClient = new WmsRestClient_1.default(billboardHost, s3BillboardUrl);
            wmsRestClient.wmsHost = billboardHost;
            wmsRestClient.wmsAuthBasic = wmsAuthBasic;
        }
        this._wmsRestClient = wmsRestClient;
    }
    _wmsRestClient;
    async getCapacityTypes(tplGuid) {
        const capacityTypesURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.CapacityTypeList);
        const result = await this._wmsRestClient.get(capacityTypesURI.href, tplGuid);
        return (result?.ResourceList ??
            []);
    }
    async getCountries(tplGuid) {
        const countryURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.Countries);
        const result = await this._wmsRestClient.get(countryURI.href, tplGuid);
        return result?.Countries ?? [];
    }
    async getItemClassifications(tplGuid) {
        const itemClassificationsURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.ItemClassificationList);
        const result = await this._wmsRestClient.get(itemClassificationsURI.href, tplGuid);
        return (result?.ResourceList ??
            []);
    }
    async getPalletTypes(tplGuid) {
        const palletTypesURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.PalletTypeList);
        const result = await this._wmsRestClient.get(palletTypesURI.href, tplGuid);
        return (result?.ResourceList ?? []);
    }
    async getUnitOfMeasureTypes(tplGuid) {
        const unitOfMeasureTypeURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.UnitOfMeasureList);
        const result = await this._wmsRestClient.get(unitOfMeasureTypeURI.href, tplGuid);
        return (result?.ResourceList ??
            []);
    }
    async getFacilities(tplGuid) {
        const facilitiesURITemplete = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.FacilityList);
        let countItems = 1;
        const facilities = [];
        const pageSize = 100;
        for (let pageNum = 1; (pageNum - 1) * pageSize < countItems; pageNum++) {
            const substituteValues = {
                pgsiz: `${pageSize}`,
                pgnum: `${pageNum}`,
            };
            const facilitiesURI = this._wmsRestClient.substituteValues(facilitiesURITemplete.href, substituteValues);
            const result = await this._wmsRestClient.get(facilitiesURI, tplGuid);
            countItems = result.TotalResults;
            facilities.push(...result.ResourceList);
        }
        return facilities;
    }
    async getCarrierList(tplGuid) {
        const carrierListURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.CarrierList);
        const result = await this._wmsRestClient.get(carrierListURI.href, tplGuid);
        return result ?? {};
    }
    async getThreePl(tplGuid) {
        const threePlUri = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.ThreePl);
        const result = await this._wmsRestClient.get(threePlUri.href, tplGuid);
        return result ?? {};
    }
    async getPackageDefs(tplGuid) {
        const packageDefURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.PropertySvc.PackageDefList);
        const result = await this._wmsRestClient.get(packageDefURI.href, tplGuid);
        return (result?.ResourceList ?? []);
    }
}
exports.default = PropertiesAccessor;
